export default "<h3>Assessment</h3>\r\n";